import { render, staticRenderFns } from "./TradeRequestDirectReport.vue?vue&type=template&id=c1081506"
import script from "./TradeRequestDirectReport.vue?vue&type=script&lang=js"
export * from "./TradeRequestDirectReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports